import React, { useState } from "react";
import {
  ExclamationTriangleIcon,
  LockClosedIcon,
  UserIcon,
} from "@heroicons/react/24/solid";
import TextInputHookForm from "../../components/TextInputHookForm";
import Button from "../../components/Button";
import loginLogo from "../../assets/images/ConfieIQLogo09042023.svg";
import { useMutation, useQuery } from "react-query";
import { checkLogin } from "../../actions/Login";
import { useRecoilState } from "recoil";
import { accountAtom } from "./atoms/AccountAtom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useHistory } from "react-router-dom";
import useGetIsAdmin from "./hooks/useGetIsAdmin";

const Login = () => {
  const { mutateAsync: getIsAdmin } = useGetIsAdmin();
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  // const [userName, setUserName] = useState("");
  // const [password, setPassword] = useState("");
  // const [loading, setLoading] = useState(false);
  // const [errorMessage, setErrorMessage] = useState("");
  const [serverError, setServerError] = useState("");
  const [, setAccount] = useRecoilState(accountAtom);
  const mutation = useMutation((userCreds) => checkLogin({ userCreds }));
  const history = useHistory();
  //Handles Submit Login
  const onSubmit = (data) => {
    mutation.mutate(data, {
      onSuccess: (res) => {
        if (res) {
          setAccount(res.data);
          mutate();

          // localStorage.setItem(
          //   "questionnaireToken",
          //   res.data.questionnaireToken
          // );
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("username", res.data.username);
          history.push("/home");
        } else {
        }
      },
      onError: (error, variables, context) => {
        setServerError(error.message);
      },
    });
  };
  const { mutate } = useMutation(() => getIsAdmin(), {
    onSuccess: (res) => {
      localStorage.setItem("admin", res.data);
    },
    onError: (error) => {
      localStorage.setItem("admin", false);
    },
  });
  return (
    <div className="w-screen h-screen flex items-center justify-center">
      <div className="containerLogin bg-white rounded-3xl h-3/6 border border-gray-200 shadow-xl sm:p-14 p-10 justify-center flex items-center divide sm:divide-x divide-x-0 sm:divide-y-0 divide-y 2xl:w-5/12 xl:w-6/12 lg:w-8/12 md:w-10/12 md:mx-0 mx-8 w-full sm:flex-row flex-col sm:space-y-0 space-y-5 ">
        <div className="w-full flex-1 flex justify-center items-center flex-col space-y-4 sm:pr-8 px-5">
          <img src={loginLogo} className="w-full object-cover" alt="logo" />
        </div>
        <form
          className="flex-1 space-y-4 sm:pl-8 pl-0  sm:pt-0 pt-5 "
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="uppercase text-center text-xs font-bold text-bg-primary">
            Enter your account
          </div>

          <TextInputHookForm
            name="Username"
            className="block w-full text-login bg-white h-8 bg-clip-padding leading-normal outline-none focus:ring-septenary focus:border-septenary"
            placeholder="Username"
            preIcon={UserIcon}
            register={register}
            validation={{ required: true }}
            type="text"
          />
          {errors.username && (
            <div className="flex whitespace-no-wrap mt-4 text-xs text-red-500 font-semibold">
              {" "}
              <i className="align-middle mr-4">
                <ExclamationTriangleIcon className="h-4 w-4 -mr-2" />
              </i>{" "}
              <span> This is a required field </span>{" "}
            </div>
          )}
          <TextInputHookForm
            name="Password"
            className="block w-full text-login bg-white h-8 bg-clip-padding leading-normal outline-none focus:ring-septenary focus:border-septenary"
            placeholder="Password"
            preIcon={LockClosedIcon}
            register={register}
            type="password"
            validation={{ required: true }}
          />
          {errors.username && (
            <div className="flex whitespace-no-wrap mt-4 text-xs text-red-500 font-semibold">
              {" "}
              <i className="align-middle mr-4">
                <ExclamationTriangleIcon className="h-4 w-4 -mr-2" />
              </i>{" "}
              <span> This is a required field </span>{" "}
            </div>
          )}
          {/* <TextInput
            id="text-password"
            className="block w-full text-login bg-white h-8 bg-clip-padding leading-normal outline-none focus:ring-septenary focus:border-septenary"
            placeholder="Password"
            preIcon={LockClosedIcon}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            type="password"
          /> */}
          {serverError && (
            <div className="flex whitespace-no-wrap mt-4 text-xs text-red-500 font-semibold">
              {" "}
              <i className="align-middle mr-4">
                <ExclamationTriangleIcon className="h-4 w-4 -mr-2" />
              </i>{" "}
              <span> {serverError} </span>{" "}
            </div>
          )}

          <Button
            // buttonValue={loading ? "Signing in.." : "Sign In"}
            disabled={mutation.isLoading}
            className={
              (mutation.isLoading
                ? "opacity-50 cursor-default !w-fit px-2"
                : "opacity-100") +
              " rounded-full bg-primary uppercase  w-full shadow-2xl h-7 px-1"
            }
          >
            <div className="flex justify-center items-center">
              <div
                className={
                  mutation.isLoading
                    ? "spinner-border animate-spin inline-block w-4 h-4 mr-2 border-2 rounded-full"
                    : ""
                }
                role="status"
              ></div>
            </div>
            <p className="shrink-0">
              {mutation.isLoading ? "Signing in.." : "Sign In"}
            </p>
          </Button>
        </form>
      </div>
    </div>
  );
};

export default Login;
